import React from "react";
import { Row, Col, Form, Button, Modal, Dropdown } from "react-bootstrap";
import {
  getContactsActions,
  deleteContactAction,
  editSetAsDefaultContactAction,
  getUserRolesAction,
  reActivateDeletedContactAction,
  editContactAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import AddContact from "../Contacts/CreateContact";
import EditContact from "../Contacts/EditContact";
import noRecord from "./../../assets/img/no-record.png";
import NoContact from "./../../assets/img/no-contact.jpg";
import PhoneNumber from "../Common/phoneNumber";
import DataTable from "react-data-table-component";
import Logo from "./../../assets/img/logo.png";
import { toastMessage, cryptoTokenDecode } from "../Common/Common";
import * as code from "../../config/Constants";
import { TextField, IconButton } from "@material-ui/core";
import {
  CheckCircle,
  CheckCircleOutline,
  Restore,
  Delete,
  Edit,
  Search,
} from "@material-ui/icons";
import { InputAdornment } from "@material-ui/core";
import UrlConstants from "../../config/UrlConstants";
import * as message from "../../config/CommonMessages";

const ClientsFilter = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search by name"
      value={filterText}
      onChange={onFilter}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      variant="standard"
    />
    <Button
      type="button"
      onClick={onClear}
      variant="primary"
      className="btn-blue btn-head ml-2"
    >
      Clear
    </Button>
  </>
);

const columns = [
  {
    name: "Name",
    selector: "firstname",
    sortable: true,
    ignoreRowClick: true,
  },
  {
    name: "Role",
    selector: "role",
    sortable: true,
  },
  {
    name: "Phone Number",
    selector: "mobileNumber",
    sortable: true,
  },
  {
    name: "Email",
    selector: "email",
    sortable: true,
    width: "25%",
  },
  {
    name: "Status",
    selector: "isDeletedVendor",
    sortable: true,
    width: "115px",
  },
  {
    name: "",
    selector: "edit",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
  {
    name: "",
    selector: "delete",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
];

function Clients({
  getContactsActions,
  getUserRolesAction,
  deleteContactAction,
  reActivateDeletedContactAction,
}) {
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );
  const [clients, setClients] = React.useState([]);
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [contactData, setContactData] = React.useState({});
  const [userType, setUserType] = React.useState(cryptoTokenDecode().usertype);
  const [currentRole, setCurrentRole] = React.useState(
    localStorage.getItem("currentRole")
  );
  const [showLoader, setShowLoader] = React.useState(false);

  React.useEffect(() => {
    setShowLoader(true);
    getAllClients();
  }, []);

  function getAllClients() {
    let rolename = "admin";
    if (userType === message.VENDOR && currentRole === message.BUYERAGENT) {
      rolename = "ep";
      getContactsActions(
        rolename,
        "?id=" + localStorage.getItem("ownerId") + "&rolename=" + rolename
      )
        .then((res) => {
          getUserRolesAction("?id=" + localStorage.getItem("ownerId"));
          setClients(res.data);
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      getContactsActions("Client")
        .then((res) => {
          getUserRolesAction();
          setClients(res.data);
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    return clients;
  }

  function deleteClient(id) {
    // console.log("ClientOld Id",id)
    deleteContactAction(id)
      .then((res) => {
        getAllClients();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function showAddClientModal() {
    setShowAddModal(true);
    // console.log("url", UrlConstants.SiteUrl + "clients");
  }

  function closeAddModal() {
    setShowAddModal(false);
    getAllClients();
  }

  function editClient(id) {
    setShowEditModal(true);
    setContactData({
      id: id,
    });
  }

  function closeEditModal() {
    setShowEditModal(false);
    getAllClients();
  }

  function reActivateUser(userId) {
    reActivateDeletedContactAction(userId)
      .then((response) => {
        getAllClients();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  let rows = [];
  for (var i = 0; i < clients.length; i++) {
    let client = clients[i];

    let contactData = {
      id: client.id,
      firstname: client.firstname + " " + client.lastname,
      role: client.roles,
      mobileNumber: <PhoneNumber phoneNumber={client.mobileNumber} />,
      email: client.email,
      isDeletedVendor:
        client.isDeletedVendor === false ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          <CheckCircleOutline className="check-out" />
        ),
      delete:
        client.isDeletedVendor === false ? (
          <IconButton
            onClick={() =>
              deleteClient(client.contactId) && !client.isDeletedVendor === true
            }
          >
            <Delete />
          </IconButton>
        ) : (
          <IconButton
            onClick={() =>
              reActivateUser(client.contactId) && !client.isDeletedVendor
            }
          >
            <Restore />
          </IconButton>
        ),
      edit:
        client.isDeletedVendor === false ? (
          <IconButton
            onClick={() =>
              editClient(client.contactId) && !client.isDeletedVendor
            }
          >
            <Edit />
          </IconButton>
        ) : (
          ""
        ),
    };

    rows.push(contactData);
  }
  const filteredClients = rows.filter(
    (contact) =>
      (contact.role === "Client" &&
        (contact.firstname &&
          contact.firstname
            .toLowerCase()
            .includes(filterText.toLowerCase()))) ||
      (contact.lastname &&
        contact.lastname.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <ClientsFilter
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  });

  return (
    <div>
      <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
        <Col xs="4">
          <h4 className="title-med mt-0 pt-1">Clients</h4>
        </Col>
        <Col align="right" className="contact-btn">
          <Button
            variant="primary"
            className="btn-blue btn-head"
            onClick={() => {
              // if (localStorage.getItem("isActive") === "false") {
              //   toastMessage(
              //     code.ERROR,
              //     "Your subscription is not active, Please activate to continue."
              //   );
              // } else {
              //   showAddClientModal();
              // }

              showAddClientModal();
            }}
          >
            Add Client
          </Button>
        </Col>
      </Row>

      {showLoader ? (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : rows.length === 0 ? (
        <div className="no-transaction">
          <div className="no-transaction-inner">
            <img src={Logo} className="no-transaction-content" alt="" />
            <h2 className="no-transaction-content">No clients found</h2>
            <hr />
            <Button
              className="text-uppercase btn-orange btn-orange-lg"
              onClick={() => {
                // if (localStorage.getItem("isActive") === "false") {
                //   toastMessage(
                //     code.ERROR,
                //     "Your subscription is not active, Please activate to continue."
                //   );
                // } else {
                //   showAddClientModal();
                // }

                showAddClientModal();
              }}
            >
              Add Client
            </Button>
          </div>
        </div>
      ) : (
        <DataTable
          title="Contacts"
          columns={columns}
          data={filteredClients}
          pagination
          paginationResetDefaultPage={resetPaginationToggle}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          persistTableHead
        />
      )}

      <Modal
        show={showAddModal}
        onHide={() => closeAddModal()}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        className="modal-med"
        backdrop={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Add Client
          </Modal.Title>
        </Modal.Header>
        <AddContact onClose={() => closeAddModal()} />
      </Modal>

      <Modal
        show={showEditModal}
        onHide={() => closeEditModal()}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        className="modal-med"
        backdrop={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Edit Client
          </Modal.Title>
        </Modal.Header>
        <EditContact
          contactData={contactData}
          onClose={() => closeEditModal()}
        />
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
  };
};

export default connect(
  mapStateToProps,
  {
    getContactsActions,
    deleteContactAction,
    editSetAsDefaultContactAction,
    getUserRolesAction,
    reActivateDeletedContactAction,
    editContactAction,
  }
)(Clients);
